import React, { useEffect } from "react";
import { Materials } from "./Materials";
import { Models } from "./Models";
import BoardMaterial from "./BoardMaterial";
import { LegsManager } from "../../functions/LegsManager";

export const LegStyles = ({
  legsMaterials,
  legsModels,
  activeStep,
  handleNextStep,
  handlePrevStep,
  activeProduct,
  setActiveProduct,
  notFull,
  basePrice,
  setLegPrice,
  setOverrideStep,
  state,
  setState,
}) => {
  const items = [
    {
      materials: [
        {
          name: "Drvo",
          next_step: false,
          board_thickness: [{ name: "2cm" }, { name: "4cm" }, { name: "7cm" }],
        },
      ],
    },
    {
      materials: [{ name: "Keramika", next_step: true }],
    },
    {
      materials: [{ name: "Staklo", next_step: true }],
    },
  ];
  useEffect(() => {
    if (notFull) {
      handlePrevStep();
    }
  }, [notFull]);

  const manager = new LegsManager(
    activeProduct,
    setActiveProduct,
    basePrice,
    setLegPrice,
    setState,
    state
  );

  return (
    <div class="leg-styles">
      <p class="poppins-20-700 leg-styles__title">Noge</p>
      {notFull && (
        <BoardMaterial
          activeStep={activeStep == 1}
          items={items}
          setActiveProduct={setActiveProduct}
          onComplete={handleNextStep}
          manager={manager}
          setOverrideStep={setOverrideStep}
        />
      )}
      <Materials
        isActive={activeStep == 2}
        onComplete={handleNextStep}
        items={legsMaterials}
        manager={manager}
        setOverrideStep={(override) => {
          if (notFull) {
            setOverrideStep(override);
          } else {
            setOverrideStep(override + 2);
          }
        }}
      />
      <Models
        isActive={activeStep == 3}
        onComplete={handleNextStep}
        items={legsModels}
        activeProduct={activeProduct}
        setActiveProduct={setActiveProduct}
        setLegPrice={setLegPrice}
        manager={manager}
      />
    </div>
  );
};
